import {ValueEditorProps} from "react-querybuilder";
import * as tackStyles from "../vulsourceitem/Tack.module.css";
import {InputNumber, Select, Tooltip} from "antd";
import {AntDValueEditor} from "@react-querybuilder/antd";
import React from "react";
import MarkdownContent from "../common/MarkdownContent";
import {QuestionCircleTwoTone} from "@ant-design/icons";
import {vulSourceSystemLastComparator} from "../../domain/VulSource";
import * as descriptionStyles from "../SelectItemDescription.module.css";
import SelectAllMultiSelect from "../common/SelectAllMultiSelect";
import {definedValues} from "../../utils/SelectOptionUtils";
import {isValuelessAttributeOperator} from "../../utils/RqbOperatorUtils";

function CustomValueEditor(props: ValueEditorProps) {
    if (props.fieldData.name.startsWith("attributes-") && isValuelessAttributeOperator(props.operator)) {
        return null;
    }

    if (props.fieldData.name === 'source.id') {
        const sources = props.fieldData.values
            ? [...props.fieldData.values].sort(vulSourceSystemLastComparator)
            : undefined;

        return (
            <SelectAllMultiSelect
                selectAllValues={definedValues(sources, source => source.id)}
                filterOption={(inputValue, option) => {
                    const normalizedInput = inputValue.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
                    const normalizedLabel = option.label?.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");

                    return normalizedLabel.includes(normalizedInput);
                }}
                popupMatchSelectWidth={350}
                optionLabelProp={"label"}
                virtual={false}
                value={props.value}
                onChange={value => props.handleOnChange(value)}>

                {sources?.map(source =>
                    <Select.Option key={source.id} value={source.id} label={source.name}>
                        {source.owner === 'SYSTEM' && <div className={`${tackStyles.tack} ${tackStyles['tack-seal']}`}><span className={tackStyles['tack-text']} color={"#440084"}>SEAL</span></div>}
                        {source.owner === 'ORGANIZATION' && <div className={`${tackStyles.tack} ${tackStyles['tack-org']}`}><span className={tackStyles['tack-text']} color={"#87d068"}>ORG</span></div>}

                        <div className={tackStyles.item}>
                            <div className={descriptionStyles['name-container']}>
                                <span className={descriptionStyles.name}>{source.name}</span>
                                {source.description && <Tooltip title={<MarkdownContent children={source.description}/>}><QuestionCircleTwoTone/></Tooltip>}
                            </div>
                            <div className={descriptionStyles.description}>{source.description}</div>
                        </div>
                    </Select.Option>
                )}

            </SelectAllMultiSelect>
        );
    }

    if (props.fieldData.name.startsWith("aiAttributes-")) {
        if (["VALUE_TEXT", "VALUE_TEXTS", "VALUE_SUMMARY"].includes(props.fieldData.aiAttributeResultType)) {
            if (props.fieldData.values?.length > 0) {
                return (
                    <Select
                        value={props.value}
                        onChange={value => props.handleOnChange(value)}
                        options={props.fieldData.values.map(v => ({value: v.name, label: v.label}))}
                    />
                );
            }

            return <AntDValueEditor {...props} />;
        }

        return (
            <InputNumber
                min={0}
                max={1}
                step={0.05}
                value={props.value}
                onChange={value => props.handleOnChange(value)}
            />
        );
    }

    return (
        <AntDValueEditor {...props} />
    );
}

export default CustomValueEditor;
